module.exports = __webpack_public_path__ + "static/media/ly.a6d11461.svg";